<!-- tabs -->
<div id="longtabs">
  <dx-tabs
    [dataSource]="tab"
    (onItemClick)="selectTab($event)"
    [scrollByContent]="true"
    [showNavButtons]="true"
    [selectedIndex]="0"
    [rtlEnabled]="currentLang == 'ar'">
  </dx-tabs>
</div>

<div *ngIf="activetab == 0">
  <app-attending-leaving-data></app-attending-leaving-data>
</div>

<div *ngIf="activetab == 1">
  <app-attending-leaving-from-excel></app-attending-leaving-from-excel>
</div>

<div *ngIf="activetab == 2">
  <app-finger-print-devices></app-finger-print-devices>
</div>

<div *ngIf="activetab == 3">
  <app-import-finger-print></app-import-finger-print>
</div>

<div *ngIf="activetab == 4">
  <app-edit-attending-leaving></app-edit-attending-leaving>
</div>